import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { setSidebarClose } from "../../../ReduxToolkit/Reducers/LayoutSlice";
import { SVG } from "../../../AbstractElements";

const CloseButton = () => {
  const {sidebarClose} = useAppSelector((state)=> state.layout)
  const dispatch = useAppDispatch()
  return (
    <SVG className={`toggle-sidebar sidebar-toggle stroke-icon`} iconId="Grid" onClick={()=>dispatch(setSidebarClose(!sidebarClose))}/>
  );
};

export default CloseButton;
